import React from 'react';
import { RemoveThreadIcon } from '../removethreadIcon/RemoveThreadIcon';

type Props = {
  hidden?: boolean;
};

export const DeleteThread: React.FC<Props> = ({ hidden }): JSX.Element => {
  const attrs = {
    wrapper: {
      className: 'detele-thread-row',
    },

    RemoveIcon: {
      isHidden: hidden,
    },
  };

  return (
    <div {...attrs.wrapper}>
      <RemoveThreadIcon {...attrs.RemoveIcon} />
    </div>
  );
};
